document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-modal-generic]').forEach((modal) => {
    const triggerType = modal.dataset.triggerType;
    const trigger = modal.dataset.trigger;
    const once = modal.dataset.once;
    const delay = parseInt(modal.dataset.delay, 10);
    const id = modal.closest('section').id;
    const venues = modal.dataset.venues?.split(',').filter(Boolean) ?? [];

    let previouslyFocused = null;

    const openModal = () => {
      previouslyFocused = document.activeElement;
      modal.classList.remove('hidden');
      modal.removeAttribute('inert');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('tabindex', '-1');
      modal.focus();
      setTimeout(() => {
        document.body.style.overflow = 'hidden';
      }, 10);
    }

    const closeModal = () => {
      modal.classList.add('hidden');
      modal.setAttribute('inert', '');
      modal.removeAttribute('aria-modal');
      modal.removeAttribute('role');
      modal.removeAttribute('tabindex');
      document.body.style.overflow = '';
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }

    const removeModalHash = () => {
      if (window.location.hash === '#' + trigger) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        window.dispatchEvent(new HashChangeEvent('hashchange'));
      }
    }

    const triggerModalClose = () => {
      if(triggerType === 'link'){
        removeModalHash();
      }else{
        closeModal();
      }
    }

    modal.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'Escape':
          triggerModalClose();
          break;
        case 'Tab': 
          const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          } else if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
          break;
      }
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        triggerModalClose();
      }
    });

    modal.querySelector('.close-modal').addEventListener('click', (e) => {
      e.preventDefault();
      triggerModalClose();
    });

    const autoOpenModal = () => {
      const currentVenue = get_venue();

      if(venues.length > 0 && !venues.includes(currentVenue)) return;

      if(!sessionStorage.getItem('modal-' + id)){
        setTimeout(() => {
          openModal();
          
          if(once){
            sessionStorage.setItem('modal-' + id, "1");
          }
        }, delay * 1000);
      }
    }

    if(triggerType === 'link'){
      if (window.location.hash === '#' + trigger) {
        openModal();
      }

      window.addEventListener('hashchange', () => {
        if (window.location.hash === '#' + trigger) {
          openModal();
        } else {
          closeModal();
        }
      });
    }else if(triggerType === 'auto'){
      autoOpenModal();
    }
  });
});
